{
  "submit": "Send",
  "submitHint": "Velg tommel opp eller ned for å sende.",
  "confirmation": "Takk for din tilbakemelding!",
  "error": "Beklager, det oppstod en feil. Vennligst prøv igjen senere.",
  "tryAgain": "Prøv igjen",
  "yes": "Ja",
  "no": "Nei",
  "like": "Liker",
  "dislike": "Misliker",
  "close": "Lukk",
  "feedback": "Gi tilbakemelding",
  "turnstileLoading": "Sikkerhetssjekk pågår...",
  "block": {
    "title": "Fant du det du lette etter?",
    "negativeLabel": "Så synd. Hva slags informasjon var du på utkikk etter?",
    "positiveLabel": "Så bra, vil du gi en tilbakemelding?",
    "placeholder": "Din kommentar..."
  },
  "footer": {
    "title": "Hva synes du om denne siden?",
    "placeholder": "Din tilbakemelding..."
  }
}
